import { z } from 'zod';

export const newsFormSchema = z.object({
  title: z.string()
    .min(1, 'El título es requerido')
    .max(255, 'El título debe tener máximo 255 caracteres'),
  headline: z.string()
    .max(500, 'El titular debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  content: z.string()
    .max(5000, 'El contenido debe tener máximo 5000 caracteres')
    .optional()
    .or(z.literal('')),
  development: z.string()
    .max(5000, 'El desarrollo debe tener máximo 5000 caracteres')
    .optional()
    .or(z.literal('')),
  url: z.string()
    .url('Debe ser una URL válida')
    .max(500, 'La URL debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  priority: z.number()
    .int('Debe ser un número entero')
    .min(0, 'La prioridad mínima es 0')
    .max(10, 'La prioridad máxima es 10')
    .default(0),
  is_active: z.boolean().default(true),
});

export type NewsFormData = z.infer<typeof newsFormSchema>;
